import { SxProps } from '@mui/system';
import { styled, Theme } from '@mui/material';
import { ReactComponent as BrokenRectangle } from '../icons/BrokenRectangle.svg';

interface CerebroBrokenBox extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	sx?: SxProps<Theme>;
}

export const CerebroBrokenBox: React.FC<CerebroBrokenBox> = ({ children, ...props }) => {
	return (
		<Wrapper {...props}>
			{children}
			<StyledBrokenRectangle />
		</Wrapper>
	);
};

const Wrapper = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.gray.background,

	marginLeft: '10px',

	padding: theme.spacing(4.5),
	position: 'relative',
}));

const StyledBrokenRectangle = styled('div')(({ theme }) => ({
	borderWidth: 1,
	borderStyle: 'solid',
	borderColor: theme.palette.gray.medium,
	borderRadius: theme.shape.borderRadius,

	pointerEvents: 'none',
	position: 'absolute',
	left: -10,
	top: -10,
	height: '100%',
	width: '100%',
}));
